import React from "react";
import { Redirect, Route } from "react-router-dom";
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { listOutline, home, settingsSharp } from "ionicons/icons";
import Home from "./pages/Home";
import Setting from "./pages/Setting";
import Record from "./pages/Record";
import Process from "./pages/Process";
import PrivateRoute from "./components/PrivateRoute";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";

import { AppProvider } from "./context";

const App: React.FC = () => {
  const languages = window.navigator.languages
  const basename = process.env.BASENAME || '';
  document.documentElement.lang = languages[0]
  return (
    <AppProvider>
      <IonApp>
        <IonReactRouter basename={basename}>
          <IonTabs>
            <IonRouterOutlet>
              <PrivateRoute path="/home" component={Home} exact={true} />
              <PrivateRoute path="/setting" component={Setting} exact={true} />
              <PrivateRoute path="/record" component={Record} />
              <Route path="/process" component={Process} />
              <Route
                path="/"
                render={() => <Redirect to="/process" />}
                exact={true}
              />
            </IonRouterOutlet>
            <IonTabBar slot="bottom">
              <IonTabButton tab="record" href="/record">
                <IonIcon icon={listOutline} />
                <IonLabel>打卡記錄</IonLabel>
              </IonTabButton>
              <IonTabButton tab="home" href="/home">
                <IonIcon icon={home} />
                <IonLabel>主頁</IonLabel>
              </IonTabButton>
              <IonTabButton tab="setting" href="/setting">
                <IonIcon icon={settingsSharp} />
                <IonLabel>設定</IonLabel>
              </IonTabButton>
            </IonTabBar>
          </IonTabs>
        </IonReactRouter>
      </IonApp>
    </AppProvider>
  );
};

export default App;
